import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {NavigationTabsModuleController} from "../navigation-tabs-module.controller";

export class NavigationTabsModuleProps extends BaseModuleProps {
  controller: NavigationTabsModuleController;
}
